<div class="business-comp">
    <div class="business-comp-header font-class-one">
        <span><b>Confirm deletion</b></span>
        <a class="close-business-comp" (click)="closeConfimationBox()" >
            <i class="fas fa-times" style="color:white;"></i>
        </a>
        <p class="margin-two"> </p>
    </div>
  
    <div class="business-comp-content-section font-class margin-class-top">
        By removing the business component, you will lose the connection with
        its associated client projects.
    </div>

    <div class="business-comp-content-section font-class">
        Are you sure you want to remove this business component?
    </div>
    <br />
    <br />
    <div class="business-comp-content-section " style="flex-direction:column">
        <button type='button' class="btn font-class-two btn-delete" (click)="deleteSelectedBusinessComp()">
            Delete
        </button>
        <a (click)="closeConfimationBox()" class="btn-back">Go Back</a>
    </div>

</div>
